import type { OAuthConfig } from './types';
import {
    createUserManager as _createUserManager,
    configureUserManager as _configureUserManager,
    configureMockUserManager as _configureMockUserManager,
} from './login';
import { attemptInitialSignin as _attemptInitialSignin } from './initialSignin';

// reexport types and util function
export type { OAuthConfig, RioProfile, SessionRenewedResult } from './types';
export { handleSilentSigninRedirectInIframe } from './redirect';

export class RioUserManager {
    public readonly userManager;

    constructor(
        oauthConfig: OAuthConfig,
        loginConfig: {
            redirectUri: string;
            silentRedirectUri?: string;
            authority: string;
            clientId: string;
            oauthScope?: string[];
            mock?: boolean;
            mockLocale?: string;
            mockTenant?: string;
        }
    ) {
        if (loginConfig.mock) {
            this.userManager = _configureMockUserManager(oauthConfig, {
                mockLocale: loginConfig.mockLocale ?? 'en-GB',
                mockTenant: loginConfig.mockTenant ?? 'rio-eu.test',
            });
        } else {
            const userManager = _createUserManager(loginConfig);
            this.userManager = _configureUserManager(oauthConfig, userManager);
        }
    }

    async attemptInitialSignin(options: {
        redirectUri: string;
        preventRedirect: boolean;
        reportError: (err: unknown) => void;
        extraQueryParams?: Record<string, string | number | boolean>;
    }) {
        return _attemptInitialSignin(this.userManager, options);
    }

    async signinSilent() {
        return this.userManager.signinSilent();
    }

    async clearStaleState() {
        return this.userManager.clearStaleState();
    }
}

export const isRunningInIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        // An exception usually indicates a cross-origin iframe scenario.
        return true;
    }
};
